<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      width="30%"
    >
      <v-card>
        <v-card-title
          class="headline pb-1"
          primary-title
        >
          Edit Market
        </v-card-title>

        <v-card-text class="pt-0">
          <v-form ref="renameForm" @submit.prevent="didApply">
            <v-text-field
              label="Market name"
              v-model="marketName"
              :rules="[rules.required]"
              autofocus
              required
            >
            </v-text-field>
            
            <v-text-field
              label="Location"
              v-model="locationString"
              @input="geocodeLocation"
              class="location-input"
              persistentHint
              :hint="geocodingError"
              :rules="[rules.required]"
              :append-icon="locationInputIcon"
              required
            >
            </v-text-field>
            
            <v-btn type="submit" style="display:none;">Submit</v-btn>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="didApply()"
            :disabled="!this.marketName.length || !this.locationGeocodedDataFound || this.locationLoading"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  name: 'custom-market-renamer',
  data () {
    return {
      marketName: '',
      locationString: '',
      geocodingError: '',
      locationLoading: false,
      geocodingTimeout: Object,
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },

  props: [ 
    'show',
    'market'
  ],

  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },
    didApply() {
      if(!this.marketName.length || !this.locationGeocodedDataFound || this.locationLoading){
        return
      }

      this.$emit('did-apply', { name: this.marketName, geocodedData: this.geocodedData, locationString: this.locationString })
      this.$emit('close-dialog')
    },
    clearVals() {
      this.$refs.renameForm.reset()
      this.marketName = ''
      this.locationString = ''
      this.$store.commit('setCustomMarketGeocodedData', {})
    },
    geocodeLocation() {
      this.locationLoading = true
      if(this.geocodingTimeout){
        clearTimeout(this.geocodingTimeout);
      }
      
      this.geocodingTimeout = setTimeout(() => {
        this.$store.dispatch('geocodeLocation', this.locationString)
      }, 1000)
    }
  },

  computed: {
    locationInputIcon() {
      if(this.locationLoading) {
        return 'fa-circle-notch fa-spin'
      } else if(this.locationGeocodedDataFound) {
        return 'check'
      } else {
        return ''
      }
    },
    geocodedData() {
      return this.$store.getters.customMarketGeocodedData
    },
    locationGeocodedDataFound() {
      return this.locationString && this.geocodedData && this.geocodedData.latitude && this.geocodedData.longitude
    },
    marketParams() {
      return this.$store.getters.marketParams
    }
  },

  watch: {
    geocodedData() {
      this.locationLoading = false
      if(!this.locationGeocodedDataFound && this.locationString.length){
        this.geocodingError = "Unable to find location."
      } else {
        this.geocodingError = ""
      }
    },
    show() {
      if(!this.show) return
      if(this.market && this.market.id != 0 && this.market.name && this.market.name != "Add a Custom Market"){
        this.marketName = this.market.name
        this.locationString = this.market.locationString || this.market.name
        var latLong = { latitude: this.market.latitude, longitude: this.market.longitude, costPerContainerAtNearestPort: null }
        this.$store.commit('setCustomMarketGeocodedData', latLong)
      } else {
        this.clearVals()
      }
    }
  },

  components: {
  }
}

</script>

<style>
.location-input i.fa-circle-notch::before {
  padding-bottom: 2px;
}
</style>